<template>
    <v-container class="fill-height" style="display: block;" fluid>

        <div id="ag-grid-network-devices-container" v-if="permission">
            <ag-grid-vue style="width: 100%; height: 100%;" class="ag-theme-balham" v-if="showGrid"
                :gridOptions="gridOptions"
                @row-double-clicked="editNetworkDevice"
                :isRowMaster="isRowMaster"
                :masterDetail="true"
                :detailCellRendererParams="detailCellRendererParams"
                :groupHeaders="true"
                :rowHeight="40">
            </ag-grid-vue>
        </div>
        <v-btn color="#c42111" class="mt-3 mr-3" @click="addNewDeviceClick" :disabled="lockSave || !isTsAdmin" v-if="permission">New</v-btn>

        <v-dialog v-model="showEditItem" max-width="80%" width="800px" :persistent="true" v-if="showEditItem" @keydown="(k) => {k.key == 'Escape' ? showEditItem = false : null}">
            <network-device-edit :networkDeviceClone="editNetworkDeviceClone" :existingDeviceNames="existingDeviceNames" @cancel="cancelClicked" @save="saveClick" />
        </v-dialog>

        <span class="no-perms" v-if="!permission">You do not have permissions to view Network Device Configurations</span>

    </v-container>
</template>

<script>
import { alarmDateFilterParams } from "@/components/Alarms/AlarmFuncs";
import { AgGridVue } from "ag-grid-vue";
import "../../node_modules/ag-grid-community/dist/styles/ag-grid.css";
import "../../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css";
import NetworkDeviceEdit from "@/components/Devices/NetworkDeviceEdit";
export default {
    name: 'NetworkDevices',
    props: [],
    components: {
        'ag-grid-vue': AgGridVue,
        NetworkDeviceEdit
    },
    data: () => ({
        networkDevicesList: [],
        configItems: null,
        showGrid: false,
        gridOptions: {},
        isRowMaster: null,
        detailCellRendererParams: {},
        lockSave: false,
        permission: true,
        showEditItem: false,
        editNetworkDeviceClone: null
    }),

    computed: {
        isTsAdmin: function() {
            return (this.$store.state.user.user_data && this.$store.state.user.user_data.is_telsasoft_admin);
        },

        existingDeviceNames: function() {
            return this.networkDevicesList.map(x => x.device);
        }
    },

    methods: {
        getNetworkDevicesList: function() {
            this.showGrid = false;
            let route = (TELSA.apiHost + "networkdevices/list");
            TELSA.loading(true);
            return this.$http.get(route).then(response => {
                let result = response.body;
                this.networkDevicesList = result;
            });
        },

        getTsIniConfig: function() {
            TELSA.loading(true);
            let route = (TELSA.apiHost + "auth/tsiniconfig");
            return this.$http.get(route).then(response => {
                let result = response.body;
                this.configItems = result;
            });

        },

        buildAgGrid: function() {
            this.showGrid = false;
            this.gridOptions = {};
            this.gridOptions.rowData = this.networkDevicesList;
            this.gridOptions.columnDefs = this.createColumnDefs();
            this.detailCellRendererParams = this.createSubColumnDefs();
            let self = this;
            this.gridOptions.onGridReady = function(params) {
                self.gridOptions.api.hideOverlay();
                self.gridOptions.api.sizeColumnsToFit();
            };

            this.isRowMaster = function(data) {
                return (data.repeats && data.repeats.length);
            };

            this.gridOptions.getContextMenuItems = function() {
                return [
                    'copy',
                    'copyWithHeaders',
                    'paste',
                    'csvExport',
                    'excelExport',
                    {
                        name: 'AI Analyser',
                        disabled: !self.$store.state.batchConfig.webapp_openai,
                        action: function() {
                            self.$store.commit('setAiAnalyzerContext', 'networkDevices');
                            self.$store.commit('setAiAnalyzerGridAPI', self.gridOptions.api);
                            self.$store.commit('setShowAIAnalyzer', true);
                        },
                        icon: `<i data-v-10101010101="" aria-hidden="true" class="v-icon notranslate mdi mdi-lightning-bolt theme--dark"></i>`
                    },
                ];
            };

            this.gridOptions.defaultColDef = {
                sortable: true,
                filter: true,
                resizable: true
            }
            this.showGrid = true;
        },

        createColumnDefs: function() {
            let columnDefs = [];
            const self = this;
            columnDefs = [
                { 
                    headerName: '',
                    suppressSizeToFit: true,
                    width: 50, filter: 'text', cellStyle: {'padding-top': '5px', 'text-align': 'left', 'background-color': 'white', 'border-right': 'black solid 1px'},
                    cellRenderer: function(params) {
                        let eElement = document.createElement('div');
                        eElement.innerHTML = `<span class="mdi mdi-pencil-circle network-device-action" style="cursor: ${self.lockSave || !self.isTsAdmin ? 'default' : 'pointer'}; color: ${self.lockSave || !self.isTsAdmin ? '#E0E0E0' : '#c42111'}; font-size: 20pt" />`

                        const editButton = eElement.querySelectorAll('.network-device-action')[0];

                        editButton.addEventListener('click', function() {
                            event.stopPropagation();
                            if(!self.lockSave && self.isTsAdmin) {
                                this.editNetworkDevice(params);
                            }
                        }.bind(this));
                        return eElement;
                    }.bind(this)
                },
                { 
                    headerName: 'Device', 
                    width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    field: 'device',
                    cellRenderer: "agGroupCellRenderer",
                },
                { 
                    headerName: 'Address', 
                    width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    field: 'address'
                },
                { 
                    headerName: 'Port', 
                    width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    field: 'port'
                },
                { 
                    headerName: 'Protocol', 
                    width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    field: 'protocol'
                },
                { 
                    headerName: 'Username', 
                    width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    field: 'username'
                },
                { 
                    headerName: 'Password', 
                    width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    field: 'password'
                },
                { 
                    headerName: 'Changed At', 
                    width: 150, cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    filter: 'agDateColumnFilter',
                    filterParams: alarmDateFilterParams,
                    valueGetter: function(params) {
                        if(!params.data.changed_at) {
                            return;
                        }
                        return TELSA.moment(params.data.changed_at).format('YYYY-MM-DD HH:mm:ss');
                    }
                },
                { 
                    headerName: 'Changed By', 
                    width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    field: 'changed_by'
                },
                {
                    headerName: 'Status', 
                    width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    field: 'status',
                    cellRenderer: function(params) {
                        if(params.data.data && params.data.data.disabled === true) {
                            return `<span data-v-d1e4e7ee="" class="v-chip theme--dark v-size--small red"><span class="v-chip__content">Disabled</span></span>`;
                        }
                        return `<span data-v-d1e4e7ee="" class="v-chip theme--dark v-size--small green"><span class="v-chip__content">Enabled</span></span>`;
                    }
                }
            ];
            return columnDefs;
        },

        createSubColumnDefs: function() {
            let self = this;
            return {
                detailGridOptions: {
                    columnDefs: [
                        { field: "device" },
                        { field: "address" },
                        { field: "port" },
                        { field: "protocol" },
                        { field: "username" },
                        { field: "password" },
                        {
                            headerName: "Changed At",
                            field: "changed_at",
                            valueGetter: function(params) {
                                if(!params.data.changed_at) {
                                    return;
                                }
                                return TELSA.moment(params.data.changed_at).format('YYYY-MM-DD HH:mm:ss');
                            }
                        },
                        { field: "changed_by" }
                    ],
                    onFirstDataRendered(params) {
                        params.api.sizeColumnsToFit();
                    }
                },
                onGridReady: params => {
                    params.api.setDomLayout("autoHeight");
                },
                getDetailRowData: params => {
                    params.successCallback(params.data.repeats);
                }
            };
        },

        editNetworkDevice: function(params) {
            if(!this.isTsAdmin || this.lockSave) {
                return;
            }
            let device = params.data;
            this.editNetworkDeviceClone = JSON.parse(JSON.stringify(device));
            this.showEditItem = true;
        },

        cancelClicked: function() {
            this.showEditItem = false;
            this.editNetworkDeviceClone = null;
        },

        addNewDeviceClick: function() {
            console.log('add new');
            this.editNetworkDeviceClone = {
                device: "",
                address: "",
                port: null,
                protocol: "",
                username: "",
                password: "",
                settings: [],
                data: {disabled: false}
            }
            this.showEditItem = true;
        },

        saveClick: function() {
            this.showEditItem = false;
            delete this.editNetworkDeviceClone.repeats; // No need to send up the repeats.
            let route = (TELSA.apiHost + "networkdevices/edit");
            TELSA.loading(true);
            return this.$http.post(route, {args: {device: this.editNetworkDeviceClone}}).then(response => {
                let result = response.body;
                Promise.all(this.getPageData()).then(r => {TELSA.loading(false); this.buildAgGrid()});
            });
        },

        getPageData: function() {
            let promises = [];
            promises.push(this.getNetworkDevicesList());
            promises.push(this.getTsIniConfig());
            return promises;
        }
    },

    mounted() {
        // Permissions Check
        this.permission = TELSA.checkPermission(this.$store.state.user, 'admin/device-passwords');

        if(!this.permission) {
            this.lockSave = true;
            return;
        }
        else if(!this.isTsAdmin) {
            this.lockSave = true;
            this.getNetworkDevicesList().then(r => {
                this.buildAgGrid();
                TELSA.loading(false);
            })
            return;
        }

        let promises = [];
        let editNetworkDevicesLockOwner, editTsIniLockOwner = null;
        promises.push(this.$store.dispatch('getLock', 'edit_network_devices').then(lockOwner => {editNetworkDevicesLockOwner = lockOwner}));
        promises.push(this.$store.dispatch('getLock', 'edit_tsini').then(lockOwner => {editTsIniLockOwner = lockOwner}));
        promises = promises.concat(this.getPageData());

        Promise.all(promises).then(v => {
            TELSA.loading(false);
            if(editNetworkDevicesLockOwner) {
                this.lockSave = true;
                this.$store.commit('showConfirmModal', {
                    title: 'Lock Warning',
                    message: `Network devices configuration is already locked for editing by <font color="#FB8C00"><b>${editNetworkDevicesLockOwner}</b></font>. You cannot save any changes at this time.`,
                    type: 'warning',
                    hideCancel: true,
                    confirmAction: function(){}
                });
            }
            else if(editTsIniLockOwner) {
                this.lockSave = true;
                this.$store.commit('showConfirmModal', {
                    title: 'Lock Warning',
                    message: `The tsini config is already locked for editing by <font color="#FB8C00"><b>${editTsIniLockOwner}</b></font>. You cannot save any changes at this time.`,
                    type: 'warning',
                    hideCancel: true,
                    confirmAction: function(){}
                });
            }
            this.buildAgGrid();
        });
    }
};
</script>

<style scoped>

    #ag-grid-network-devices-container {
        height: calc(100vh - 126px);
    }

</style>

<style>

    #ag-grid-network-devices-container .ag-theme-balham .ag-icon.ag-icon-tree-closed {
        color: #000000;
        font-weight: bold;
        margin-top: -10px;
        font-size: 20px;
    }

    .no-perms {
        font-size: 26px;
        display: block;
        text-align: center;
        color: lightgray;
        margin-top: calc(50vh - (80px + 25px));
    }

</style>
